import ddt from '@wix/da-ddt';
import { isSSR } from '../utils';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
class Primis {
    logBi(eventData) {
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            window.addEventListener('primisPlayerInit', (e)=>{
                const player = e.detail;
                if (player) {
                    const playerId = player.playerApiId;
                    player.addEventListener('adStarted', (v)=>{
                        ddt.log('ads', 'Primis AD START', playerId, v);
                        this.logBi(BiData({
                            evid: 8810,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            impValue: `${v.impValue}`,
                            servingFee: `${v.servingFee}`
                        }));
                    });
                    player.addEventListener('adCompleted', (v)=>{
                        ddt.log('ads', 'Primis AD COMPLETE', playerId, v);
                        this.logBi(BiData({
                            evid: 8811,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue
                        }));
                    });
                    player.addEventListener('adClickthrough', (v)=>{
                        ddt.log('ads', 'Primis AD CLICK', playerId, v);
                        this.logBi(BiData({
                            evid: 8812,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue
                        }));
                    });
                    player.addEventListener('adFirstQuartile', (v)=>{
                        ddt.log('ads', 'Primis Ad 1st Quart', playerId, v);
                        this.logBi(BiData({
                            evid: 8813,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            quartile_completed: 1
                        }));
                    });
                    player.addEventListener('adMidQuartile', (v)=>{
                        ddt.log('ads', 'Primis Ad mid Quart', playerId, v);
                        this.logBi(BiData({
                            evid: 8813,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            quartile_completed: 2
                        }));
                    });
                    player.addEventListener('adThirdQuartile', (v)=>{
                        ddt.log('ads', 'Primis Ad third Quart', playerId, v);
                        this.logBi(BiData({
                            evid: 8813,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            quartile_completed: 3
                        }));
                    });
                    player.addEventListener('adPause', (v)=>{
                        ddt.log('ads', 'Primis Ad Pause', playerId, v);
                        this.logBi(BiData({
                            evid: 8814,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            control_type: 'pause'
                        }));
                    });
                    player.addEventListener('adPlay', (v)=>{
                        ddt.log('ads', 'Primis Ad 1st Play', playerId, v);
                        this.logBi(BiData({
                            evid: 8814,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            control_type: 'play'
                        }));
                    });
                    player.addEventListener('adSkip', (v)=>{
                        ddt.log('ads', 'Primis Ad Skip', playerId, v);
                        this.logBi(BiData({
                            evid: 8814,
                            adUnitId: playerId,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue,
                            control_type: 'skip'
                        }));
                    });
                }
            });
            window.addEventListener('pagehide', ()=>{
                this.flushBiQueue();
            });
        }
    }
    registerUnit(unitId, options, safety) {
        if (safety === 'off') {
            ddt.log('ads', 'Skipped register because ads are OFF', unitId);
            return;
        }
        if (!isSSR()) {
            ddt.log('ads', 'register primis client ad', unitId);
            const params = new URLSearchParams();
            params.append('s', options.placementId);
            params.append('vp_content', options.vpContent);
            params.append('playerApiId', unitId);
            params.append('floatDirection', 'br');
            params.append('floatWidth', '360');
            params.append('floatMode', 'below');
            params.append('floatVerticalOffset', options.verticalOffset);
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = `https://live.primis.tech/live/liveView.php?${params.toString()}`;
            const container = document.getElementById(unitId);
            if (!container) {
                ddt.log('ads', 'Failed to register primis unit', unitId);
                return;
            }
            container.appendChild(script);
        }
    }
    killUnit(unitId) {}
    toSSR() {
        return '';
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    constructor(){
        this.ssrUnits = {};
        this.logQueue = [];
    }
}
export default Primis;
